module.exports = __webpack_public_path__ + "media/images/clickworker_com/2fa_step_1-97eb3282df89ca478c3926c450220c45.png";